import { z } from 'zod';
export const stateSchema = z.string().meta({ autocomplete: 'address-level1' });
